import {ExperimentNames, getFormattedFullLocation} from '@wix/wix-events-commons-statics'
import {ChevronUp} from '@wix/wix-ui-icons-common'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useWidgetState} from '../../../../../../../../hooks/state-provider'
import {useVisibilityStyles} from '../../../../../../../../hooks/use-visibility-styles'
import {getMultiDayText, getRibbonData, shouldShowPromotionalBadge} from '../../../../../../../../selectors/events'
import {EventImage} from '../../../../../../../event-image'
import {LinkToPage} from '../../../../../../../link-to-page'
import {Members} from '../../../../../../../members'
import {PromotionalBadge} from '../../../../../../../promotional-badge'
import {Ribbon} from '../../../../../../../ribbon'
import {RsvpButton} from '../../../../../../../rsvp-button'
import {SocialBar} from '../../../../../../../social-bar'
import {MobileMonthlyEventDetailsProps} from './interfaces'
import s from './mobile-monthly-event-details.scss'

export const MobileMonthlyEventDetails = ({
  event,
  hasImage,
  showMembers,
  date,
  multiDay,
  showRibbon,
  closeMonthlyCalendarEvent,
  state,
  selectedDate,
}: MobileMonthlyEventDetailsProps) => {
  const {t} = useTranslation()
  const {experiments} = useExperiments()
  const {
    allBreakpoints: {isPromotionalBadgeInEventInfo},
  } = useVisibilityStyles()

  const multiDayText = getMultiDayText(state, event.id, selectedDate, t)
  const hasRibbon = getRibbonData(state, event).visible
  const showPromotionalBadge = useWidgetState(state => shouldShowPromotionalBadge(state, event))

  const handleEventClick = () => {
    closeMonthlyCalendarEvent()
  }

  return (
    <div className={s.container}>
      <div className={s.eventInfo} onClick={handleEventClick} data-hook={`event-details-${event.id}`}>
        {experiments.enabled(ExperimentNames.PromotionalBadges) &&
          showPromotionalBadge &&
          isPromotionalBadgeInEventInfo() && (
            <div className={classNames(s.promotionalBadge, {[s.margin]: !showRibbon || !hasRibbon})}>
              <PromotionalBadge event={event} />
            </div>
          )}
        {showRibbon ? <Ribbon event={event} className={s.ribbon} /> : null}
        {multiDay ? (
          <div className={s.time}>{multiDayText}</div>
        ) : (
          <div className={s.fullDate} data-hook="date">
            {date}
          </div>
        )}
        <div
          className={classNames({
            [s.multiDayTitle]: multiDay,
            [s.title]: !multiDay,
          })}
          data-hook="title"
        >
          <LinkToPage event={event}>{event.title}</LinkToPage>
          <div className={s.chevron}>
            <ChevronUp size="1.2em" />
          </div>
        </div>
      </div>
      {hasImage ? (
        <div className={s.image}>
          <EventImage event={event} />
        </div>
      ) : null}
      {multiDay ? (
        <div className={s.fullDate} data-hook="date">
          {date}
        </div>
      ) : null}
      <div className={s.location} data-hook="location">
        {getFormattedFullLocation(event)}
      </div>
      {showMembers ? (
        <div className={s.members} data-hook="members">
          <Members event={event} />
        </div>
      ) : null}
      {event.description ? (
        <div className={s.description} data-hook="description">
          {event.description}
        </div>
      ) : null}
      <div className={s.share} data-hook="share">
        <div className={s.shareText}>{t('shareEventText')}</div>
        <SocialBar t={t} spacing={7} event={event} iconFontSize={14} newColors={false} row hideTitle />
      </div>
      <RsvpButton
        event={event}
        dataHook="rsvp-button"
        minWidth={88}
        maxWidth={170}
        minHeight={32}
        additionalStyle={{fontSize: 14}}
        containerClassName={s.button}
      />
    </div>
  )
}
